export default "__VITE_ASSET__801ee976__"